import { render, staticRenderFns } from "./sba-pagination-nav.vue?vue&type=template&id=a35196f0&scoped=true&"
import script from "./sba-pagination-nav.vue?vue&type=script&lang=js&"
export * from "./sba-pagination-nav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a35196f0",
  null
  
)

export default component.exports